import { render, staticRenderFns } from "./OpportunitiesTab.vue?vue&type=template&id=7120d07d&scoped=true&"
import script from "./OpportunitiesTab.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OpportunitiesTab.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OpportunitiesTab.vue?vue&type=style&index=0&id=7120d07d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7120d07d",
  null
  
)

export default component.exports